import React from "react";

import './Button.scss';

const Button = props => {
	const {children, disabled, leftIcon, leftFontIcon, rightIcon, onClick, width, center, type, padding} = props;

	let color = 'white';
	let bgColor = '#142B31';
	let border = '1px solid transparent';

	switch (type) {
		case 'danger':
			bgColor = '#E65051';
			break;
		case 'blue':
			bgColor = disabled ? '#dddddd' : '#40A0C1';
			break;
		case 'success':
			bgColor = disabled ? '#dddddd' : '#71C89E';
			break;
		case 'transparent':
			color = 'black';
			bgColor = 'transparent';
			border = '1px solid #D3E1ED';
		case 'text':
			color = '#40A0C1';
			bgColor = 'transparent';
			border = 'none';
			break;
	}

	const w = width ? `${width}px` : 'auto';
	const jc = center ? 'center' : 'space-between';
	const cur = disabled ? 'default' : 'pointer';

	return (
		<div className="button-component-container" onClick={disabled ? null : onClick} style={{padding: padding || '0 10px',backgroundColor: bgColor, border, color, width: w, justifyContent: jc, cursor: cur}}>
			{leftIcon && <img src={leftIcon} alt="" />}
			{leftFontIcon && leftFontIcon}
			<div>{children}</div>
			{rightIcon && <img style={{paddingTop: '2px'}} src={rightIcon} alt="" />}
		</div>
	)
};

export default Button;
